import { EcommerceProduct } from '../../models/ecommerce-product.interface';
import { ActionType as AT } from './enums/action-type.enum';

export const reviewProduct = (product: EcommerceProduct) => ({
  type: AT.REVIEW_PRODUCT,
  payload: { product }
});

export const addProductToCart = (product: EcommerceProduct) => ({
  type: AT.ADD_PRODUCT_TO_CART as AT.ADD_PRODUCT_TO_CART,
  payload: { product }
});

export const removeLastProductFromCart = () => ({
  type: AT.REMOVE_PRODUCT_FROM_CART as AT.REMOVE_PRODUCT_FROM_CART,
  payload: null
});

export const purchaseProducts = () => ({
  type: AT.PURCHASE_PRODUCTS as AT.PURCHASE_PRODUCTS,
  payload: null
});